import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';

import { VideoHttpService } from './video-http.service';
import { VideoProgress } from '@core/models/video-progress';
import { KeepWatching } from '@modules/home/models/keep-watching';
import { Video } from '@core/models/video';

@Injectable({
	providedIn: 'root'
})
export class VideoService {

	private videoHttpService = inject(VideoHttpService);

	private _watchedList = signal<string[]>([]);
	private _keepWatching = signal<KeepWatching[]>([]);
	private _recommendations = signal<Video[]>([]);
	private _videoContent = signal<any>(null);
	private _hasAttemptedLoad = signal<boolean>(false);

	public watchedList = computed(() => this._watchedList());
	public keepWatching = computed(() => this._keepWatching());
	public recommendations = computed(() => this._recommendations());

	public videoContent = computed(() => this._videoContent());
	public hasAttemptedLoad = computed(() => this._hasAttemptedLoad());

	public getWatched() {

		this.videoHttpService.getProgressList()
			.subscribe({
				next: (videoProgress: VideoProgress[]) => {
					this._watchedList.set(videoProgress.filter((x: any) => x.percentage >= 90).map((x: any) => x.uuid));
				}
			});
	}

	public getKeepWatching() {

		this.videoHttpService.getKeepWatching()
			.subscribe({
				next: (keepWatching: KeepWatching[]) => {
					this._keepWatching.set(keepWatching);
				}
			});
	}

	public getRecommendations() {

		this.videoHttpService.getRecommendations()
			.subscribe({
				next: (recommendations: Video[]) => {
					this._recommendations.set(recommendations);
				}
			});
	}

	public getProgress(uuid: string): Observable<VideoProgress> {

		return this.videoHttpService.getProgress(uuid);
	}

	public storeProgress(uuid: string, progress: number, duration: number) {

		this.videoHttpService.storeProgress(uuid, progress)
			.subscribe({
				next: () => {
					this.getKeepWatching();
				}
			});
	}

	public getVideoContent(slug: string) {

		this._hasAttemptedLoad.set(false);

		this.videoHttpService.getVideoContent(slug)
			.pipe(
				catchError(() => of(null))
			)
			.subscribe({
				next: (videoContent: any) => {
					this._hasAttemptedLoad.set(true);
					this._videoContent.set(videoContent);
				}
			});
	}

	public resetVideoContent() {

		this._videoContent.set(null);
		this._hasAttemptedLoad.set(false);
	}
}